<template>
  <div class="page-wrap page-layout-config-area">
    <jw-card class="config-card">
      <!-- 布局配置，字段配置， -->
      <jw-tabs :header-padding="false" :active-key="data.fieldsKey" class="object-form-tabs" size="small" @tab-click="tabsFeildChange">
        <jw-tab-pane key="1" :title="getTitle"> </jw-tab-pane>
        <jw-tab-pane key="2" :title="$t(grayList['Layout:viewInit'] ? '其他设置' : '布局属性')"> </jw-tab-pane>
      </jw-tabs>
      <!-- 字段，组件等属性配置 -->
      <template v-if="data.fieldsKey == 1">
        <div class="layout-config-container" v-if="data.sendType?.modules">
          <div class="layout-config-container-content layout-config-form-content scrollbar-style-config" ref="layoutConfigRef">
            <jw-form :model="data.form" layout="vertical" label-align="left">
              <template v-if="data.sendType?.area != 'tab'">
                <!-- 字段名称，组件名称等 -->
                <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" class="form-item-title">
                  <template #label>
                    {{ getModuleLabel }}
                    <jw-tag v-if="[20, 35].includes(Number(data.sendType?.modules?.type) || Number(data.sendType?.modules?.layoutFieldType))" size="small" color="green">{{ data.sendType.modules.systemFieldtype == 0 ? $t('系统字段') : data.sendType.modules.systemFieldtype == 1 ? $t('基础字段') : $t('自定义字段') }}</jw-tag>
                  </template>
                  <jw-input disabled v-model="getModuleValue"> </jw-input>
                </jw-form-item>
              </template>

              <!-- 详情页配置区 -->
              <template v-if="data.sendType?.page == 20">
                <template v-if="data.sendType.area === 'module'">
                  <!-- 协作人 -->
                  <template v-if="data.sendType?.modules?.[0]?.value === 1">
                    <collaborator-config :sendType="data.sendType" :followButtonCollection="layoutTableBtnModules" @updateData="handleUpdateData"></collaborator-config>
                  </template>

                  <!-- 历史报价 -->
                  <jw-form-item v-if="data.sendType.modules[0].value === 2 && data.sendType.modules[0].controlType == 2" field="isShowFollow" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('是否展示')" :row="1" />
                    </template>
                    <jw-radio-group v-model="data.sendType.modules[0].display">
                      <jw-radio :value="1">{{ $t('是') }}</jw-radio>
                      <jw-radio :value="0">{{ $t('否') }}</jw-radio>
                    </jw-radio-group>
                  </jw-form-item>
                  <!-- 动态记录 -->
                  <template v-if="data.sendType.modules[0].value === 2 && data.sendType.modules[0].controlType == 1">
                    <dynamics-config :sendType="data.sendType" @updateData="handleUpdateData" @addCondition="addCondition"></dynamics-config>
                  </template>

                  <jw-form-item v-else-if="data.sendType.modules[0].value === 3" field="isShowFlowStageConfig" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('是否展示')" :row="1" />
                    </template>
                    <jw-radio-group v-model="data.sendType.modules[0].display">
                      <jw-radio :value="1">{{ $t('是') }}</jw-radio>
                      <jw-radio :value="0">{{ $t('否') }}</jw-radio>
                    </jw-radio-group>
                  </jw-form-item>
                </template>
                <!-- 页签配置区  tab -->
                <template v-else-if="data.sendType.area === 'tab'">
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('页签名称')" :row="1" />
                    </template>
                    <jw-input v-model="data.sendType.modules.label" :placeholder="$t('请输入页签名称')" allow-search allow-clear> </jw-input>
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('显示条件')" :row="1" />
                    </template>
                    <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.display" :placeholder="$t('请选择显示条件')" allow-search allow-clear @change="changeDisplay" :options="data.conditionSelectList" />
                  </jw-form-item>
                  <jw-form-item v-if="data.sendType.modules.display == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <jw-button type="outline" v-if="!data.sendType.modules.displayConditions" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('添加条件') }}</jw-button>
                    <jw-button v-else type="outline" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('tips.conditionsCount', { count: data.sendType.modules.displayConditions?.children?.length || 0 }) }}</jw-button>
                  </jw-form-item>
                  <div v-if="tabComponent.includes(data.sendType.modules.value)">
                    <!-- 页签内置组件按钮配置区 -->
                    <btn-group :list="layoutTableBtnModules[data.sendType.modules.value]" @cb="onBtnConfigChange" type="150" popup-container=".layout-config-form-content" :sort="false" />
                  </div>
                </template>
                <!-- 查询记录，关联记录 -->
                <template v-else-if="getRecordType(data.sendType.modules?.layoutFieldType)">
                  <association-table-config :source="20" :pId="pId" :sendType="data.sendType" @updateData="handleUpdateData"></association-table-config>
                </template>
                <!-- 关联对象字段 -->
                <template v-else-if="data.sendType.modules?.layoutFieldType == 50">
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('显示条件')" :row="1" />
                    </template>
                    <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.display" :placeholder="$t('请选择显示条件')" :options="data.conditionSelectList" allow-search allow-clear @change="changeDisplay"> </jw-select>
                  </jw-form-item>
                  <jw-form-item v-if="data.sendType.modules.display == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <jw-button type="outline" v-if="!data.sendType.modules.displayConditions" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('添加条件') }}</jw-button>
                    <jw-button v-else type="outline" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('tips.conditionsCount', { count: data.sendType.modules.displayConditions?.children?.length || 0 }) }}</jw-button>
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('关联对象')" :row="1" />
                    </template>
                    <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.businessData" :placeholder="$t('请选择关联对象')" :options="data.objectOptions" allow-search allow-clear @change="objectChange" :class="{ 'error-select': isShowError(1) }" :fallback-option="fallbackOption"> </jw-select>
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('关联主键')" :row="1" />
                    </template>
                    <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.associateKey" :placeholder="$t('请选择关联主键')" :options="data.findAssociation?.filter((v) => v?.fieldExt == pId)" allow-search allow-clear @change="associatedPrimaryKey"> </jw-select>
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('显示字段')" :row="1" />
                    </template>
                    <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.associateField" :placeholder="$t('请选择显示字段')" :options="data.allObjectFields" allow-search allow-clear @change="showField"> </jw-select>
                  </jw-form-item>
                </template>
                <!-- 外链容器 -->
                <template v-else-if="data.sendType.modules?.layoutFieldType == 60">
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('容器名称')" :row="1" />
                    </template>
                    <jw-input v-model="data.sendType.modules.name" :placeholder="$t('容器名称')" />
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('电脑端外链地址')" :row="1" />
                    </template>
                    <jw-textarea :max-length="1024" show-word-limit v-model="data.sendType.modules.pcUrl" :placeholder="$t('电脑端外链地址')" />
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('移动端外链地址')" :row="1" />
                    </template>
                    <jw-textarea :max-length="1024" show-word-limit v-model="data.sendType.modules.mobileUrl" :placeholder="$t('移动端外链地址')" />
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('外框类型')" :row="1" />
                    </template>
                    <jw-radio-group v-model="data.sendType.modules.borderType">
                      <jw-radio value="solid">
                        {{ $t('实线') }}
                        <jw-tooltip :content="$t('设置容器在详情页显示时的外边框')">
                          <span><icon-question-circle /></span>
                        </jw-tooltip>
                      </jw-radio>
                      <jw-radio value="dashed">{{ $t('虚线') }}</jw-radio>
                      <jw-radio value="none">{{ $t('无') }}</jw-radio>
                    </jw-radio-group>
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('显示高度')" :row="1" />
                    </template>
                    <jw-input-number v-model="data.sendType.modules.height" :placeholder="$t('显示高度')" :precision="0" :min="0" :max="9999">
                      <template #suffix>px</template>
                    </jw-input-number>
                  </jw-form-item>
                </template>
                <template v-else>
                  <!-- 详情子表单子字段不显示是否可见  -->
                  <template v-if="fieldAttributeOutLayout.includes(userInfo.orgId)">
                    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" v-if="data.sendType.modules.parentFieldType != 27">
                      <template #label>
                        <xl-label-text :value="$t('显示条件')" :row="1" />
                      </template>
                      <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.display" :placeholder="$t('请选择显示条件')" :options="data.conditionSelectList" allow-search allow-clear @change="changeDisplay"> </jw-select>
                    </jw-form-item>
                    <jw-form-item v-if="data.sendType.modules.display == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <jw-button type="outline" v-if="!data.sendType.modules.displayConditions" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('添加条件') }}</jw-button>
                      <jw-button v-else type="outline" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('tips.conditionsCount', { count: data.sendType.modules.displayConditions?.children?.length || 0 }) }}</jw-button>
                    </jw-form-item>
                  </template>
                  <jw-form-item :label-col-style="{ width: '120px' }" field="toast" :rules="toastRules" :validate-trigger="['blur', 'change']" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('字段提示')" :row="1" />
                    </template>
                    <!-- <jw-textarea v-if="data.sendType.modules.value === 'mobile'" v-model="data.sendType.modules.toast" :max-length="confine.number5001" :placeholder="$t('请输入字段提示信息')" :auto-size="{ minRows: 2, maxRows: 5 }"  disabled> </jw-textarea> -->
                    <jw-textarea v-model="data.sendType.modules.toast" :max-length="confine.number5001" :placeholder="$t('请输入字段提示信息')" :auto-size="{ minRows: 2, maxRows: 5 }" allow-search allow-clear> </jw-textarea>
                  </jw-form-item>
                  <jw-form-item :label-col-style="{ width: '120px' }" field="memo" :rules="memoRules" :validate-trigger="['blur', 'change']" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('附加说明')" :row="1" />
                    </template>
                    <jw-input v-model="data.sendType.modules.memo" :placeholder="$t('请输入附加说明信息')" :max-length="confine.number5001" allow-search allow-clear> </jw-input>
                  </jw-form-item>
                  <!-- 日期范围展示没意义 隐藏掉 -->
                  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" v-if="data.sendType.modules.fieldType != 9 && (data.sendType.modules.fieldType != 21 || data.sendType.modules?.business?.fieldType != 9)">
                    <template #label>
                      <xl-label-text :value="$t('默认提示文本')" :row="1" />
                    </template>
                    <jw-input v-model="data.sendType.modules.placeholder" :placeholder="$t('请输入默认提示文本')" allow-search allow-clear> </jw-input>
                  </jw-form-item>
                  <jw-modal :width="400" @ok="confirmSubSort" v-model:visible="isSubFieldSet" :title="$t('字段设置')" title-align="start">
                    <jw-tree class="sub-config-tree" :selected-keys="[]" @drop="dropEnd" draggable :blockNode="true" :data="tmpModules" :field-names="{ title: 'label', key: 'value' }">
                      <template #icon>
                        <icon-drag-dot-vertical />
                      </template>
                      <template #title="nodeData">
                        {{ nodeData.label }}
                      </template>
                      <template #drag-icon></template>
                    </jw-tree>
                  </jw-modal>
                </template>
              </template>

              <!-- 新增编辑页配置区 -->
              <template v-else>
                <!-- 字段 -->
                <template v-if="data.sendType.modules?.layoutFieldType == 20 || data.sendType.modules?.layoutFieldType == 35">
                  <template v-if="data.sendType.modules.fieldType != 21 && data.sendType.modules.fieldType != 24 && fieldAttributeOutLayout.includes(userInfo.orgId)">
                    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <template #label>
                        <xl-label-text :value="$t('是否必填')" :row="1" />
                      </template>
                      <!-- addIsRequired这个字段控制,新增布局时,如果字段是必填,不可更改 -->
                      <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.isRequired" :disabled="data.sendType.modules.addIsRequired" :placeholder="$t('请选择是否必填')" :options="data.mustFillInList" allow-search allow-clear @change="changeRequired"> </jw-select>
                    </jw-form-item>
                    <jw-form-item v-if="data.sendType.modules.isRequired == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <jw-button v-if="!data.sendType.modules.requiredConditions" type="outline" long @click="isRequiredConditions(data.sendType.modules.requiredConditions)">{{ $t('添加条件') }}</jw-button>
                      <jw-button v-else type="outline" long @click="isRequiredConditions(data.sendType.modules.requiredConditions)">{{ $t('tips.conditionsCount', { count: data.sendType.modules.requiredConditions?.children?.length || 0 }) }}</jw-button>
                    </jw-form-item>
                  </template>
                  <template v-if="fieldAttributeOutLayout.includes(userInfo.orgId)">
                    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" v-if="data.sendType.modules?.parentFieldType != 27">
                      <template #label>
                        <xl-label-text :value="$t('显示条件')" :row="1" />
                      </template>
                      <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.display" :placeholder="$t('请选择显示条件')" :options="data.conditionSelectList" :disabled="data.sendType.modules.isRequired == 1 || data.sendType.modules.isRequired == 2" allow-search allow-clear @change="changeDisplay"> </jw-select>
                    </jw-form-item>
                    <jw-form-item v-if="data.sendType.modules.display == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <jw-button type="outline" v-if="!data.sendType.modules.displayConditions" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('添加条件') }}</jw-button>
                      <jw-button v-else type="outline" long @click="addCondition(data.sendType.modules.displayConditions)">{{ $t('tips.conditionsCount', { count: data.sendType.modules.displayConditions?.children?.length || 0 }) }}</jw-button>
                    </jw-form-item>
                  </template>
                  <template v-if="data.sendType?.page == 40 && data.sendType.modules.fieldType != 24 && data.sendType.modules.fieldType != 27 && fieldAttributeOutLayout.includes(userInfo.orgId)">
                    <jw-form-item field="businessData" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <template #label>
                        <xl-label-text :value="$t('编辑页可修改')" :row="1" />
                      </template>
                      <jw-radio-group :disabled="objectDisableFieldKeys.includes(data.sendType.modules.value)" v-model="data.sendType.modules.businessData">
                        <jw-radio value="1">{{ $t('是') }}</jw-radio>
                        <jw-radio value="0">{{ $t('否') }}</jw-radio>
                        <!-- <jw-radio :value="2">{{$t('满足条件可编辑')}}</jw-radio> -->
                      </jw-radio-group>
                    </jw-form-item>
                  </template>
                  <template v-if="data.sendType?.page == 40 && data.sendType.modules.fieldType == 27 && fieldAttributeOutLayout.includes(userInfo.orgId)">
                    <jw-form-item field="businessData" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <template #label>
                        <xl-label-text :value="$t('编辑页可修改')" :row="1" />
                      </template>
                      <jw-radio-group :disabled="objectDisableFieldKeys.includes(data.sendType.modules.value)" v-model="data.sendType.modules.permission">
                        <jw-radio :value="1">{{ $t('是') }}</jw-radio>
                        <jw-radio :value="0">{{ $t('否') }}</jw-radio>
                      </jw-radio-group>
                    </jw-form-item>
                  </template>
                  <template v-if="data.sendType?.page == 40 && data.sendType.modules.fieldType == 27 && data.sendType.modules.permission == 1 && fieldAttributeOutLayout.includes(userInfo.orgId)">
                    <jw-form-item field="permissionDetail" :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <template #label>
                        <xl-label-text :value="$t('编辑规则设置')" :row="1" />
                      </template>
                      <jw-checkbox-group direction="vertical" v-model="data.sendType.modules.permissionDetail">
                        <jw-checkbox value="edit">{{ $t('可编辑已有记录') }}</jw-checkbox>
                        <jw-checkbox value="remove">{{ $t('可删除已有记录') }}</jw-checkbox>
                        <jw-checkbox value="add">{{ $t('可新增记录') }}</jw-checkbox>
                        <jw-checkbox value="insert">{{ $t('可插入记录') }}</jw-checkbox>
                      </jw-checkbox-group>
                    </jw-form-item>
                  </template>
                  <jw-modal :width="400" @ok="confirmSubSort" v-model:visible="isSubFieldSet" :title="$t('字段设置')" title-align="start">
                    <jw-tree class="sub-config-tree" :selected-keys="[]" @drop="dropEnd" draggable :blockNode="true" :data="tmpModules" :field-names="{ title: 'label', key: 'value' }">
                      <template #icon>
                        <icon-drag-dot-vertical />
                      </template>
                      <template #title="nodeData">
                        {{ nodeData.label }}
                      </template>
                      <template #drag-icon></template>
                    </jw-tree>
                  </jw-modal>
                  <jw-form-item :label-col-style="{ width: '120px' }" field="toast" :rules="toastRules" :validate-trigger="['blur', 'change']" label-col-flex="auto">
                    <template #label>
                      <xl-label-text :value="$t('字段提示')" :row="1" />
                    </template>
                    <!-- <jw-textarea v-if="data.sendType.modules.value === 'mobile'" v-model="data.sendType.modules.toast" :max-length="confine.number5001" :placeholder="$t('请输入字段提示信息')" :auto-size="{ minRows: 2, maxRows: 5 }"  disabled> </jw-textarea> -->
                    <jw-textarea v-model="data.sendType.modules.toast" :max-length="confine.number5001" :placeholder="$t('请输入字段提示信息')" :auto-size="{ minRows: 2, maxRows: 5 }" allow-search allow-clear> </jw-textarea>
                  </jw-form-item>
                  <template v-if="data.sendType.modules.layoutFieldType != 35">
                    <jw-form-item :label-col-style="{ width: '120px' }" field="memo" :rules="memoRules" :validate-trigger="['blur', 'change']" label-col-flex="auto">
                      <template #label>
                        <xl-label-text :value="$t('附加说明')" :row="1" />
                      </template>
                      <jw-input v-model="data.sendType.modules.memo" :placeholder="$t('请输入附加说明信息')" :max-length="confine.number5001" allow-search allow-clear> </jw-input>
                    </jw-form-item>
                    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <template #label>
                        <xl-label-text :value="$t('默认提示文本')" :row="1" />
                      </template>
                      <jw-input v-model="data.sendType.modules.placeholder" :placeholder="$t('请输入默认提示文本')" allow-search allow-clear> </jw-input>
                    </jw-form-item>
                  </template>
                  <!-- 新租户隐藏 -->
                  <template v-if="data.sendType.modules.fieldType == 12 || (data.sendType.modules.fieldType == 25 && data.sendType?.isSubForm && fieldAttributeOutLayout.includes(userInfo.orgId))">
                    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
                      <template #label>
                        <xl-label-text :value="$t('赋值规则')" :row="1" />
                      </template>
                      <jw-button type="outline" @click="toggleIsRule">{{ $t('规则配置') }}</jw-button>
                    </jw-form-item>
                  </template>
                  <!-- 开了灰度默认值规则需要把布局中的默认值给隐藏 -->
                  <template v-if="!isGrayScale">
                    <jw-form-item :label="$t('默认值')" :label-col-style="{ width: '120px' }" label-col-flex="auto" v-if="setIsVal() && data.sendType?.page == 30">
                      <template #label>
                        <xl-label-text :value="$t('默认值')" :row="1" />
                      </template>
                      <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.isExistDefValue" :placeholder="$t('请选择默认值')" :options="getDefaultOptions()" allow-search allow-clear @change="changeSelect"> </jw-select>
                    </jw-form-item>

                    <!--此处添加data.sendType.modules.value !== 'opportunityStage' && 是因为之前的商机阶段是存在默认值的（改版后需要过滤调之前保存的默认值） -->
                    <jw-form-item v-if="data.sendType.modules.value !== 'opportunityStage' && data.sendType.modules.isExistDefValue == 1" :label-col-style="{ width: '120px' }" label-col-flex="auto" :class="[data.sendType.modules.fieldType == 11 && data.sendType.modules?.defaultValue && !tools.checkLink(data.sendType.modules?.defaultValue) ? 'defaultValue-item-label-error' : '']">
                      <!-- <jw-input v-model="data.sendType.modules.defaultValue" :placeholder="$t('请输入默认值')"  allow-search  allow-clear> </jw-input> -->
                      <!-- 单行文本 -->
                      <jw-input v-if="data.sendType.modules.fieldType === 0 || data.sendType.modules.fieldType === 11" v-model="data.sendType.modules.defaultValue" :placeholder="`${$t('请输入')}${data.sendType.modules.label}`" class="system-form-item-value" />
                      <!-- 多行文本 -->
                      <jw-textarea
                        v-else-if="data.sendType.modules.fieldType == 1"
                        :placeholder="`${$t('请输入')}${data.sendType.modules.label}`"
                        v-model="data.sendType.modules.defaultValue"
                        :auto-size="{
                          minRows: 2,
                          maxRows: 5
                        }"
                        class="system-form-item-value"
                      />
                      <!-- 单选按钮 -->
                      <jw-radio-group v-else-if="data.sendType.modules.fieldType == 2" class="system-form-item-value" v-model="data.sendType.modules.defaultValue">
                        <jw-radio v-for="item in JSON.parse(data.sendType.modules.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
                      </jw-radio-group>
                      <!-- 多选按钮 -->
                      <jw-checkbox-group v-else-if="data.sendType.modules.fieldType == 3" class="system-form-item-value" v-model="data.sendType.modules.defaultValue">
                        <jw-checkbox v-for="item in JSON.parse(data.sendType.modules.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
                      </jw-checkbox-group>
                      <!-- 下拉单选 -->
                      <jw-select v-else-if="data.sendType.modules.fieldType === 4" v-model="data.sendType.modules.defaultValue" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" class="system-form-item-value" :options="JSON.parse(data.sendType.modules.fieldExt)" popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" allow-clear allow-search> </jw-select>
                      <!-- 下拉多选 -->
                      <jw-select v-else-if="data.sendType.modules.fieldType === 5" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" multiple class="system-form-item-value" v-model="data.sendType.modules.defaultValue" :options="JSON.parse(data.sendType.modules.fieldExt)" popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" allow-search allow-clear> </jw-select>
                      <!-- 人员选择是一个单框与角色权限中的添加人员一样 -->
                      <template v-else-if="data.sendType.modules.fieldType === 6">
                        <fh-person position="bl" className="member-tree-list" :maxTagCount="3" :item="data.sendType.modules.defaultValue" :multiple="tools.isJSON(data.sendType.modules?.fieldExt) ? (JSON.parse(data.sendType.modules?.fieldExt)?.single == 1 ? false : true) : true" @cb="getVal($event, `data.sendType.modulesForm.${index}.defaultValue`, index)"> </fh-person>
                      </template>

                      <!-- 数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
                      <template v-else-if="data.sendType.modules.fieldType === 7">
                        <jw-input-number v-if="JSON.parse(data.sendType.modules.fieldExt)?.numberFormat === '100'" :precision="2" v-model="data.sendType.modules.defaultValue" class="system-form-item-value" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" allow-clear hide-button>
                          <template #append> % </template>
                        </jw-input-number>
                        <jw-input-number v-else-if="JSON.parse(data.sendType.modules.fieldExt)?.numberUnit" class="system-form-item-value" v-model="data.sendType.modules.defaultValue" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" @input="(event) => getPrecisionNum(event, data.sendType.modules)" :formatter="(event) => isShowThousandFormatter(event, data.sendType.modules)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(data.sendType.modules, precisionNum)">
                          <template #append> {{ JSON.parse(data.sendType.modules.fieldExt)?.numberUnit || '' }} </template>
                        </jw-input-number>
                        <jw-input-number v-else class="system-form-item-value" v-model="data.sendType.modules.defaultValue" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" :precision="Number(JSON.parse(data.sendType.modules.fieldExt)?.numberFormat)" />
                      </template>
                      <!-- 日期格式 -->
                      <jw-date-picker v-else-if="data.sendType.modules.fieldType === 8" :show-time="data.sendType.modules.fieldExt?.indexOf('HH') > -1" v-model="data.sendType.modules.defaultValue" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" class="system-form-item-value" :format="data.sendType.modules.fieldExt" popup-container=".system-form-item" position="br" :trigger-props="{ updateAtScroll: true }" />
                      <!-- 日期范围 -->
                      <template v-else-if="data.sendType.modules.fieldType === 9">
                        <jw-range-picker v-if="data.sendType.modules.fieldExt === '0'" v-model="data.sendType.modules.defaultValue" class="system-form-item-value" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
                        <jw-range-picker v-else-if="data.sendType.modules.fieldExt === '1'" class="system-form-item-value" v-model="data.sendType.modules.defaultValue" @select="onSelect" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
                        <jw-range-picker v-else v-model="data.sendType.modules.defaultValue" class="system-form-item-value" @select="onSelect" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
                      </template>
                      <!-- 级联选择器 -->
                      <jw-cascader v-else-if="data.sendType.modules.fieldType === 10" :options="JSON.parse(data.sendType.modules.fieldExt)" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" class="system-form-item-value select-cascader-item-value" v-model="data.sendType.modules.defaultValue" :trigger-props="{ updateAtScroll: true }" path-mode allow-clear allow-search />
                      <!-- 金额 -->
                      <template v-else-if="data.sendType.modules.fieldType === 16">
                        <jw-input-number class="system-form-item-value" v-model="data.sendType.modules.defaultValue" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" @input="(event) => getPrecisionNum(event, data.sendType.modules)" :formatter="(event) => isShowThousandFormatter(event, data.sendType.modules)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(data.sendType.modules, precisionNum)" />
                      </template>
                      <!-- 附件 -->
                      <template v-else-if="data.sendType.modules.fieldType === 18">
                        <fh-attachment-upload :fieldExt="data.sendType.modules.fieldExt" v-model="data.sendType.modules.defaultValue" @cb="getFiles($event, data.sendType.modules.value)" :defaultFileList="data.sendType.modules.defaultValue" class="system-form-item-value" />
                      </template>
                      <!-- 部门 -->
                      <xl-tree-member-modal v-else-if="data.sendType.modules.fieldType === 22" class="member-tree-list" :multipleDep="data.sendType.modules?.fieldExt == 2 ? true : false" ref="xlTreeMember" :tree="departTree" @cb="getDepVal($event, `data.sendType.modulesForm.${index}.defaultValue`, index)" :depart="data.sendType.modules.defaultValue?.departList">
                        <jw-input-tag v-model="data.sendType.modules.fv" :max-tag-count="3" :memberNumber="1" readonly :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" />
                      </xl-tree-member-modal>
                      <!-- 百分比 -->
                      <jw-input-number v-else-if="data.sendType.modules.fieldType === 23" v-model="data.sendType.modules.defaultValue" class="system-form-item-value" :placeholder="`${$t('请选择')}${data.sendType.modules.label}`" allow-clear hide-button @input="(event) => getPrecisionNum(event, data.sendType.modules)" :precision="getPrecision(data.sendType.modules, precisionNum)">
                        <template #append> % </template>
                      </jw-input-number>
                      <template v-else-if="data.sendType.modules.fieldType === 26">
                        <w-editor v-model="data.sendType.modules.defaultValue" :configs="{ height: 200 }"></w-editor>
                      </template>
                      <!-- 子表单默认值 -->
                      <template v-else-if="data.sendType.modules.fieldType === 27 && data.sendType.modules.isExistDefValue == 1"></template>
                      <!-- 其他类型 -->
                      <jw-input v-else v-model="data.sendType.modules.defaultValue" :placeholder="`${$t('请输入')}${data.sendType.modules.label}`" class="system-form-item-value" />
                      <p v-if="data.sendType.modules.fieldType == 11 && data.sendType.modules?.defaultValue && !tools.checkLink(data.sendType.modules?.defaultValue)" class="link-invalid">格式不正确,请以http:// 或 https:// 开头,且不能包含汉字</p>
                    </jw-form-item>
                  </template>
                </template>
                <!-- 关联对象表格 -->
                <template v-else-if="getRecordType(data.sendType.modules?.layoutFieldType)">
                  <association-table-config :source="30" :pId="pId" :sendType="data.sendType" @updateData="handleUpdateData"></association-table-config>
                </template>
              </template>
              <!-- 0是1/2行展示，1是整行 2是1/3  3是2/3行展示 -->
              <!-- <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" v-if="data.sendType.modules?.layoutFieldType == 20 && !data.noDisplayOneLine.includes(data.sendType.modules.fieldType) && data.sendType.modules.parentFieldType != 27">
                <template #label>
                  <xl-label-text :value="$t('字段宽度')" :row="1" />
                </template>
                <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.displayOneLine" :placeholder="$t('请选择字段宽度')" :options="displayOneLine" unmount-on-close allow-search class="object-form-item-width"> </jw-select>
              </jw-form-item> -->
            </jw-form>
          </div>
        </div>
        <div class="config-empty" v-else>
          <xl-empty :msg="$t([2, 3].includes(splitType) ? '请点击选中组件进行组件属性设置' : '请点击选中字段进行字段属性设置')"></xl-empty>
        </div>
      </template>
      <!-- 布局属性 -->
      <template v-if="data.fieldsKey == 2">
        <div class="layout-config-container-content layout-form-content scrollbar-style-config" ref="layoutFormRef">
          <layout-form-config ref="layoutFormConfigRef" :form="data.form" @cb="updateFormConfig" />
        </div>
      </template>
    </jw-card>
    <show-condition ref="showConditionRef" :entity="pId" :conditions="data.sendType.modules?.displayConditions" @cb="senData"></show-condition>
    <jw-modal width="650px" @cancel="toggleIsRule" @ok="handleSetRule" :visible="isRuleModal" :title="$t('添加规则')" title-align="start">
      <jw-spin :loading="settingLoading">
        <jw-space direction="vertical" fill>
          <div v-for="(c, index) in defaultRule.cover" :key="index" style="display: flex; align-items: center">
            {{ $t('将') }}【 <span class="rule-field" :title="defaultRule.objName"> {{ defaultRule.objName }} </span>】{{ $t('的') }}
            <jw-select allow-search :error="!c.source && c.error" style="width: 150px; margin: 0 5px" v-model="c.source" :placeholder="$t('请选择')" @change="changeFirst(index)">
              <jw-option v-for="s in sourceFields" :key="s.id" :value="s.fieldKey">{{ s.fieldName }}</jw-option>
            </jw-select>
            {{ $t('赋值给本对象的') }}
            <jw-select :fallback-option="fallback" allow-search :error="!c.target && c.error" style="width: 150px; margin: 0 5px" @change="(e) => changeSecond(e, index, c)" :placeholder="$t('请选择')" v-model="c.target" :loading="c?.loading">
              <jw-option
                v-for="t in c.targetFields.filter((v) => {
                  return defaultRule.cover.find((vv, i) => v.fieldKey == vv.target && index != i) === undefined && v.fieldKey != data.sendType.modules?.value;
                })"
                :key="t.id"
                :value="t.fieldKey"
              >
                {{ t.fieldName }}
              </jw-option>
            </jw-select>
            <icon-minus-circle class="hand" size="20" @click="deleteCover(index)" />
          </div>
        </jw-space>
        <icon-plus-circle @click="addCover" style="margin: 10px 0; color: rgb(var(--primary-6))" class="add-sub-item hand" size="28" />
        <jw-space direction="vertical" fill>
          <jw-checkbox v-model:model-value="defaultRule.autoCover" style="font-size: 13px">
            <span style="display: flex">
              <span>{{ $t('用户填写') }}【</span>
              <span class="rule-field" :title="defaultRule.objName">{{ defaultRule.objName }}</span>
              <span>】{{ $t('字段时，【逻辑赋值】自动覆盖【手动填写】') }}</span>
            </span>
          </jw-checkbox>
          <jw-checkbox style="font-size: 13px" v-model:model-value="defaultRule.autoCoverAll">
            <span style="display: flex">
              <span>{{ $t('用户修改') }}【</span>
              <span class="rule-field" :title="defaultRule.objName">{{ defaultRule.objName }}</span>
              <span>】{{ $t('字段时，将根据赋值规则，对所有字段重新赋值') }}</span>
            </span>
          </jw-checkbox>
          <jw-checkbox style="font-size: 13px" v-model:model-value="defaultRule.autoClear">
            <span style="display: flex">
              <span>{{ $t('用户清空') }}【</span>
              <span class="rule-field" :title="defaultRule.objName">{{ defaultRule.objName }}</span>
              <span>】{{ $t(data?.sendType?.modules?.fieldType == 12 ? '字段时，将根据赋值规则，对所有字段同时清空' : '字段时，已赋值字段不清空') }}</span>
            </span>
          </jw-checkbox>
        </jw-space>
      </jw-spin>
    </jw-modal>
  </div>
</template>

<script setup>
import { useUserStore } from '@/store';
import { tools } from '@/utils/tools.js';
import { reactive, ref, inject, watch, computed, nextTick, provide, watchEffect } from 'vue';
import useViewFields from '@/hooks/view-fields';
import { setService } from '@/api/';
import dayjs from 'dayjs';
import { Message } from '@arco-design/web-vue';
import ShowCondition from '@/views/setting/sys-fields/page-layout/components/show-condition/show-condition.vue';
import associationTableConfig from '@/views/setting/sys-fields/page-layout/components/association-table-config/association-table-config.vue'; //设置关联表格多层级配置
import collaboratorConfig from '@/views/setting/sys-fields/page-layout/components/collaborator-config/collaborator-config.vue'; //协作人
import dynamicsConfig from '@/views/setting/sys-fields/page-layout/components/dynamics-config/dynamics-config.vue'; //协作人
import LayoutFormConfig from '@/views/setting/sys-fields/page-layout/components/layout-form-config/layout-form-config.vue'; //表单配置
import btnGroup from '@/views/setting/sys-fields/page-layout/components/btn-group/btn-group.vue'; //操作按钮组合
import { getButtonResult, ruleMap } from '@/utils/buttons.js';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { objectDisableFieldKeys, confine } from '@/utils/const';
// 精度
import useThousandOption from '@/hooks/thousand';
import getLayoutFields from '@/hooks/layout';
import { useGrayscaleStore } from '@/store';
import useObjectForm from '@/hooks/object-form';

const { grayList } = useGrayscaleStore();

const splitType = inject('sharedConfigData')?.splitType; // 布局分裂模式
const { userInfo } = useUserStore(); //用户信息
const { checkDefaultRule, getRecordType } = useObjectForm();
const { getBtnGroup, layoutTableBtnModules, tabComponent, isDeepEmptyCondition } = getLayoutFields();
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();
const useGrayScale = useGrayscaleStore(); //租户灰度
const isGrayScale = computed(() => {
  //返回true代表开了灰度默认值规则
  return useGrayScale.grayList['Layout:defaultValue'];
});
const { t } = useI18n();
const route = useRoute();
const emits = defineEmits(['cb']);
const { enableList, getViewFields } = useViewFields();
const props = defineProps({
  entity: {
    // 对象Id
    type: String,
    default: ''
  },
  name: {
    // 布局名称
    type: String,
    default: ''
  }
});
// const pId = route.params?.id ?? '101';
const pId = ref(route.params?.id ? route.params.id : props.entity ? props.entity : '101');
const isFirst = ref(true); //table是否查询关联组件（监听触发查询或者切换关联对象触发查询）
/** 子表单子字段排序相关 start **/
const isSubFieldSet = ref(false); //是否打开子表单字段排序弹窗
const tmpModules = ref([]); //临时存储子字段modules
const layoutFormConfigRef = ref(); //布局设置；
const confirmSubSort = () => {
  data.sendType.modules.modules = [...tmpModules.value];
};

// 设置标题
const getModuleLabel = computed(() => {
  let setLabel = '字段名称';

  const cmpName = grayList['Layout:viewInit'] ? '组件类型' : '组件名称';

  if (data.sendType?.modules) {
    if ([30, 31, 35, 60].includes(Number(data.sendType?.modules?.type || data.sendType?.modules?.layoutFieldType))) {
      setLabel = cmpName;
    }
    if (data.sendType.modules?.[0]?.value == 2 && data.sendType.modules?.[0]?.controlType == 1) {
      //动态记录
      setLabel = cmpName;
    }
    if (data.sendType?.modules?.[0]?.value === 1) {
      //协作人
      setLabel = cmpName;
    }
  }
  return setLabel;
});
// 获取字段名称，组件名称
const getModuleValue = computed(() => {
  let labelValue = t('字段名称');
  const getTableLayoutType = data.sendType?.modules?.type || data.sendType?.modules?.layoutFieldType;
  if (getRecordType(Number(getTableLayoutType))) {
    labelValue = getTableLayoutType == 31 ? t('查询记录') : t('关联记录');
  } else {
    labelValue = data.sendType?.modules?.label || data.sendType?.modules?.[0]?.label;
  }
  return labelValue;
});
//右侧拖拽结束
const dropEnd = ({ dragNode, dropNode, dropPosition }) => {
  const data = tmpModules.value;
  if (dropPosition === 0) {
    let dragIndex = null;
    let dropIndex = null;
    data.map((d, index) => {
      if (d.value == dragNode.value) {
        dragIndex = index;
      }
      if (d.value == dropNode.value) {
        dropIndex = index;
      }
    });
    if (dragIndex !== null && dropIndex !== null) {
      [data[dragIndex], data[dropIndex]] = [data[dropIndex], data[dragIndex]];
    }
    return false;
  }
  const loop = (data, key, callback) => {
    data.some((item, index, arr) => {
      if (item.value === key) {
        callback(item, index, arr);
        return true;
      }
      if (item.modules) {
        return loop(item.modules, key, callback);
      }
      return false;
    });
  };

  loop(data, dragNode.value, (_, index, arr) => {
    arr.splice(index, 1);
  });

  if (dropPosition === 0) {
    loop(data, dropNode.value, (item) => {
      item.modules = item.modules || [];
      item.modules.push(dragNode);
    });
  } else {
    loop(data, dropNode.value, (_, index, arr) => {
      arr.splice(dropPosition < 0 ? index : index + 1, 0, dragNode);
    });
  }
};
const { collaButtonSelected, assButtonSelected } = inject('sharedConfigData');

const fieldAttributeOutLayout = inject('sharedConfigData').fieldAttributeOutLayout;

/** 子表单子字段排序相关 end **/
const data = reactive({
  sendType: inject('sharedConfigData').sendType,
  tabIndex: inject('sharedConfigData').tabIndex, //页签的
  groupIndex: inject('sharedConfigData').groupIndex, //模块的
  operationType: inject('sharedConfigData').operationType, //操作类型
  entity: inject('sharedConfigData').pId, //当前对象的类型(entity)ID
  detailData: inject('sharedConfigData').detailData,
  source: inject('sharedConfigData').source,
  allBtnGroup: inject('sharedConfigData').allBtnGroup, //所有按钮
  defaultTableLevelConfig: [], //多层级默认配置
  noDisplayOneLine: [18, 26, 27], //不需要整行展示的字段类型
  // field: [],
  // defaultField: [],
  objectOptions: [], //所有的对象列表 格式化后的label和value并且没有已经禁用的对象
  objectList: [], //所有对象原始数据
  findAssociation: [], //查找关联字段
  allObjectFields: [], //所选对象的所有字段
  conditionSelectList: [
    { value: 0, label: '默认不可见' },
    { value: 1, label: t('默认可见') },
    { value: 2, label: t('满足条件可见') }
  ],
  mustFillInList: [
    { value: 0, label: t('非必填') },
    { value: 1, label: t('必填') },
    { value: 2, label: t('在某条件下必填') }
  ],
  defaultValueList: [
    { value: 0, label: t('不展示默认值') },
    { value: 1, label: t('展示统一默认值') }
  ],
  defaultTimeValueList: [
    { value: 0, label: t('不展示默认值') },
    { value: 1, label: t('展示统一默认值') },
    { value: 2, label: t('展示当前时间') }
  ],
  defaultPersonValueList: [
    { value: 0, label: t('不展示默认值') },
    { value: 1, label: t('展示统一默认值') },
    { value: 2, label: t('当前用户') }
  ],
  defaultDepartValueList: [
    { value: 0, label: t('不展示默认值') },
    { value: 1, label: t('展示统一默认值') },
    { value: 2, label: t('当前用户所属部门') }
  ],
  form: {
    name: '', //布局名称
    layoutDetailBtnModules: inject('sharedConfigData').layoutDetailBtnModules, //通用按钮
    showBtnCountModel: inject('sharedConfigData').showBtnCount?.value || '1' //外显数量
  },
  conditionType: 1,
  fieldsKey: '2',
  btnconfigList: [
    {
      label: '编辑',
      value: '0'
    },
    {
      label: '转化',
      value: '1'
    },
    {
      label: '领取',
      value: '2'
    },
    {
      label: '废弃',
      value: '3'
    }
  ],

  collaboratorSelectedList: [],
  assTableObjSelectedList: {},
  assQuickButtonSelectedList: {}
});

console.log('初始化eeee', data.sendType);

watchEffect(() => {
  data.form.name = props.name;
});
// 设置tab属性
const getTitle = computed(() => {
  let setTitle = [2, 3].includes(splitType?.value) ? '组件设置' : '字段属性';
  if (data.sendType?.modules) {
    if ([30, 31, 35, 60].includes(Number(data.sendType?.modules?.type || data.sendType?.modules?.layoutFieldType))) {
      setTitle = !grayList['Layout:viewInit'] ? '组件属性' : '组件设置';
    }
    if (data.sendType.modules?.[0]?.value == 2 && data.sendType.modules?.[0]?.controlType == 1) {
      //动态记录
      setTitle = !grayList['Layout:viewInit'] ? '组件属性' : '组件设置';
    }
    if (data.sendType?.modules?.[0]?.value === 1) {
      //协作人
      setTitle = !grayList['Layout:viewInit'] ? '组件属性' : '组件设置';
    }
    if (data.sendType?.area == 'tab') {
      setTitle = !grayList['Layout:viewInit'] ? '组件属性' : '组件设置';
    }
  }
  return setTitle;
});
/*************************关联对象表格抽取*******************************/

const handleUpdateData = (newData) => {
  // 更新父组件的数据
  Object.assign(data.sendType.modules, newData);
};

/*************************关联对象表格抽取*******************************/

/********** 查找关联单选配置规则 start **************/
const defaultRule = reactive({
  autoCover: true,
  autoCoverAll: true,
  autoClear: true,
  cover: [{ source: null, target: null, targetFields: [], error: false }],
  objName: null
});
const toggleFieldKey = ref(null);
const isRuleModal = ref(false);
const toggleIsRule = () => {
  isRuleModal.value = !isRuleModal.value;
};
// 可设置默认值
const setIsVal = () => {
  const { fieldType, value } = data.sendType.modules || {};
  const notISValFieldType = [12, 25, 13, 21, 24, 27]; //没有默认值类型
  const values = ['opportunityStage', 'qccId', 'cluePoolId', 'businessId', 'entityType'];
  const notvals = !values.includes(value);
  const notvalField = !notISValFieldType.includes(fieldType);
  return notvals && notvalField;
};

// 默认值下拉

const getDefaultOptions = () => {
  const { fieldType } = data.sendType.modules;
  switch (fieldType) {
    case 6:
      return data.defaultPersonValueList;
    case 22:
      return data.defaultDepartValueList;
    case 8:
      return data.defaultTimeValueList;
    default:
      return data.defaultValueList;
  }
};
const changeSecond = async (e, index, c) => {
  let entity = data.entity;
  // 判断是否是子表单 获取子表单的entity
  if (data.sendType.modules?.parentFieldType == 27) {
    entity = c.targetFields?.find((item) => item.fieldKey == e)?.entityId;
  }
  c.loading = true;
  const fieldName = c.targetFields?.find((item) => item.fieldKey == e)?.fieldName;
  const isDefaultRule = await checkDefaultRule({ fieldKey: e, entity: entity }, fieldName, 2);
  if (isDefaultRule) {
    c.target = '';
  }
  c.loading = false;
  defaultRule.cover[index].error = false;
};
const handleSetRule = () => {
  const assignRule = [];
  let isError = false;
  defaultRule.cover.map((c) => {
    if ((!c.source && c.target) || (!c.target && c.source)) {
      isError = true;
      c.error = true;
    }
    if (c.source && c.target) {
      assignRule.push({
        sourceField: c.source,
        targetField: c.target
      });
    }
  });
  if (isError) {
    return false;
  }
  data.sendType.modules['fieldAssignment'] = {
    entityFieldRuleEvent: {
      eventAdd: defaultRule.autoCover,
      eventModify: defaultRule.autoCoverAll,
      eventClear: defaultRule.autoClear
    },
    fieldAssignmentRules: assignRule
  };
  toggleIsRule();
};
/****** 关联对象表格关联对象和字段异常提示 start *******/
const isShowError = (type) => {
  if (type == 1) {
    return data.objectList?.length && data.sendType.modules?.businessData && data.objectList?.findIndex((ol) => ol?.entityType == data.sendType.modules?.businessData && ol?.isEnabled) < 0;
  } else if (type == 2) {
    return data.findAssociation?.length && data.sendType.modules?.associateKey && data.findAssociation?.findIndex((fl) => fl?.value == data.sendType.modules?.associateKey) < 0;
  }
};

const fallbackOption = (value) => {
  const _findObject = data.objectList?.find((ol) => ol?.entityType == value);
  let _label = value;
  if (_findObject?.entityName) {
    _label = _findObject?.entityName;
  }

  return {
    label: _label + (data.objectList?.length ? `（${t('异常')}）` : ''),
    value: value
  };
};
/****** 关联对象表格关联对象和字段异常提示 end *******/
const deleteCover = (index) => {
  defaultRule.cover.splice(index, 1);
};
const addCover = () => {
  defaultRule.cover.push({ source: null, target: null, targetFields: [], error: false });
};
const changeFirst = (index, reset = true) => {
  const fi = sourceFields.value.filter((v) => v?.fieldKey === defaultRule.cover[index].source)?.[0];
  if (reset) {
    defaultRule.cover[index].target = null;
  }
  const filterField = [];
  if (fi?.fieldType == 12) {
    //查找关联单选赋值规则：不能给已经有赋值规则的查找关联单选字段赋值
    data.detailData?.map((dd) => {
      if (dd?.modules) {
        dd.modules.map((ddm) => {
          if (ddm.type == 20) {
            if (ddm?.fieldType == 12 && ddm?.fieldAssignment?.fieldAssignmentRules?.length > 0) {
              filterField.push(ddm?.value); //塞入fieldKey
            }
          }
        });
      }
    });
  }
  let _sourceField = targetFields.value;
  if (data.sendType?.isSubForm) {
    targetFields.value
      .filter((v) => v.fieldType == 27)
      .map((tv) => {
        tv?.settings?.map((tvs) => {
          if (tvs.fieldKey == data.sendType?.modules?.value) {
            _sourceField = tv?.settings;
          }
        });
      });
  }
  defaultRule.cover[index].targetFields = _sourceField.filter((v) => v?.fieldType == fi?.fieldType && (v?.fieldType != 6 || (tools.isJSON(fi?.fieldExt) && JSON.parse(fi?.fieldExt)?.single == 1) || (tools.isJSON(v?.fieldExt) && JSON.parse(v?.fieldExt)?.single == 0)) && (v?.fieldType != 22 || fi?.fieldExt == 1 || v?.fieldExt == 2) && (![2, 3, 4, 5, 10].includes(v?.fieldType) || v?.globalFieldId == fi?.globalFieldId) && (![12, 25].includes(v?.fieldType) || v?.fieldExt == fi?.fieldExt) && filterField.indexOf(v?.fieldKey) < 0);
};
const fallback = (e) => {
  const fieldInfo = targetFields.value.find((v) => v?.fieldKey == e);
  return { value: e, label: fieldInfo?.fieldName || e };
};
/********** 查找关联单选配置规则 end **************/

watch(
  () => assButtonSelected,
  () => {
    data.assTableObjSelectedList = assButtonSelected;
  },
  {
    deep: true,
    immediate: true
  }
);

watch(
  () => collaButtonSelected,
  () => {
    data.collaboratorSelectedList = collaButtonSelected;
  },
  {
    deep: true,
    immediate: true
  }
);

// 点击页签
const tabsFeildChange = (key) => {
  data.fieldsKey = key;
};
//修改编辑规则
const changeEditRule = (type) => {
  //type 1.新增 2.插入
  const addPosition = data.sendType?.modules?.permissionDetail.indexOf('add');
  const insertPosition = data.sendType?.modules?.permissionDetail.indexOf('insert');
  if (addPosition < 0 && insertPosition > -1) {
    if (type == 1) {
      data.sendType?.modules?.permissionDetail.splice(insertPosition, 1);
    } else if (type == 2) {
      data.sendType?.modules?.permissionDetail.push('add');
    }
  }
};
watch(
  () => data.sendType?.modules?.permissionDetail,
  (newVal, oldVal) => {
    if (Array.isArray(newVal) && Array.isArray(oldVal)) {
      const diffVal = [];
      if (newVal.length > oldVal.length) {
        newVal.map((nv) => {
          if (oldVal.indexOf(nv) < 0) {
            diffVal.push(nv);
          }
        });
      } else {
        oldVal.map((nv) => {
          if (newVal.indexOf(nv) < 0) {
            diffVal.push(nv);
          }
        });
      }

      if (diffVal.length == 1 && diffVal[0] == 'add') {
        changeEditRule(1);
      } else if (diffVal.length == 1 && diffVal[0] == 'insert') {
        changeEditRule(2);
      }
    }
  }
);
const showConditionRef = ref();
// 是否展示
const addCondition = (conditions, conditionType) => {
  // 打开弹窗，添加条件
  console.log('1-打开弹窗-添加条件', conditions);
  if (conditionType && conditionType == 4) {
    data.conditionType = 4;
  } else {
    data.conditionType = 1;
  }
  showConditionRef.value.open(conditions, 1, data.entity);
};
// 是否必填
const isRequiredConditions = (requiredConditions) => {
  console.log('1-打开弹窗-添加条件-是否必填条件', requiredConditions);
  data.conditionType = 2;
  showConditionRef.value.open(requiredConditions, 2, data.entity);
};

// 时间范围选择 N
const onSelect = (valueString, value) => {
  console.log(valueString);
  console.log(value);
};
// 左侧列表选择激活态结束
const departTree = ref({
  checkDepartment: true,
  isAll: true,
  data: [], // 数组 必传
  checkUser: false
});
// 添加人员角色--获取部门或者用户的值
const getVal = (v, prop, index) => {
  // prop为field值，单一清除时使用
  console.log('人员选择查看:', v, index, prop);
  // 选择人员后，调添加人员接口，参数都在v中，按需去V中取
  const userNames = computed(() => v?.userList?.map((u) => u.userName));
  console.log('userNames', userNames.value);
  // data.sendType.modules.defaultValue = userNames.value;
  data.sendType.modules.defaultValue = v;
  data.sendType.modules.fv = userNames.value;
};
const getDepVal = (v) => {
  const departNames = computed(() => v?.departList?.map((u) => u.departmentName));
  data.sendType.modules.defaultValue = v;
  data.sendType.modules.fv = departNames.value;
};
//获取对象列表
const getObjectList = async () => {
  data.objectOptions = [];
  data.objectList = [];
  try {
    const json = await setService.getSysObjList({ page: 1, pageSize: 10000, type: 0 });
    if (json.error && json.error?.msg) {
      Message.error(json.error?.msg || t('操作失败'));
      return;
    }
    data.objectList = json.result?.records || [];
    data.objectOptions = json.result?.records.filter((el) => el.entityType != pId.value && el?.isEnabled).map((o) => ({ label: o.entityName, value: String(o.entityType) })); //需把当前对象过滤掉
  } catch (e) {
    console.log(e);
  }
};

// 添加通用默认按钮
const generalButtonAdd = () => {
  let defaultAddbtnCode;
  if (data.sendType?.modules?.businessData >= 200) {
    // 自定义对象
    defaultAddbtnCode = data.sendType?.modules?.businessData;
  } else {
    // 系统对象
    defaultAddbtnCode = ruleMap[data.sendType?.modules?.businessData];
  }

  data.sendType.modules.modules.push({
    type: '40',
    businessData: '0',
    value: `${defaultAddbtnCode}:add`
  });
};
//三级表格对查找关联对象的校验
// const setDataRangeConditions=(conditions)=>{
//    if (conditions.isGroup) { //分组
//      if(conditions?.children?.length>0){
//      conditions?.children?.forEach((el)=>{
//       if(el?.isGroup){ //分组
//           el?.children?.forEach((item)=>{
//            if(!item.isGroup && item?.fieldType==12 && item.operation === 'equals_current_value'){
//             item.operation='';
//            }
//        })
//       }
//   })
// }
// }
//   return conditions
// }
//切换关联对象及字段
const objectChange = async (val) => {
  isFirst.value = false;
  data.findAssociation = [];
  data.allObjectFields = [];
  data.sendType.modules.associateKey = ''; //关联建
  data.sendType.modules.associateField = ''; //关联字段
  data.sendType.modules.displayConditions = null;
  data.sendType.modules.requiredConditions = null;
  data.sendType.modules.dataRangeConditions = null;
  data.sendType.modules.modules = null;
  if (val) {
    if (data.sendType.modules?.layoutFieldType == 50) {
      await getViewFields({ id: val });
      //组件
      if (data.sendType?.page == 20) {
        //详情
        const detailEnableList = enableList.value; //全部字段
        data.sendType.modules.modules = detailEnableList.map((item) => {
          let business = {};
          if (item.fieldType == 27 && tools.isJSON(item?.business)) {
            business = JSON.parse(item?.business);
          }
          //列表页字段
          return {
            label: item.fieldName,
            value: item.fieldKey,
            isRequired: item.isRequired ? 1 : 0,
            type: item.fieldType == 27 ? '35' : '20',
            fieldType: item.fieldType,
            ...business,
            modules:
              item?.settings?.map((is) => {
                return {
                  label: is.fieldName,
                  value: is.fieldKey,
                  isRequired: is.isRequired ? 1 : 0,
                  type: '20',
                  fieldType: is.fieldType
                };
              }) || []
          };
        });
        generalButtonAdd();
      } else {
        //关联对象表格
        if (!data.sendType.modules.modules) {
          const newEnableList = enableList.value?.filter((el) => el.type && el.type !== 0 && el.fieldType != 13); //只要自定义及基础字段除去自增编码及附件
          data.sendType.modules.modules = newEnableList.map((item) => {
            //列表页字段
            let business = {};
            if (item.fieldType == 27 && tools.isJSON(item?.business)) {
              business = JSON.parse(item?.business);
            }
            return {
              label: item.fieldName,
              value: item.fieldKey,
              isRequired: item.isRequired ? 1 : 0,
              type: item.fieldType == 27 ? '35' : '20',
              fieldType: item.fieldType,
              ...business,
              modules:
                item?.settings?.map((is) => {
                  return {
                    label: is.fieldName,
                    value: is.fieldKey,
                    isRequired: is.isRequired ? 1 : 0,
                    type: '20',
                    fieldType: is.fieldType
                  };
                }) || []
            };
          });
        }
        generalButtonAdd();
      }
    }

    data.findAssociation = enableList.value
      .filter((f) => f.fieldType === 12)
      .map((f) => {
        return { label: f.fieldName, value: f.fieldKey, fieldExt: f.fieldExt };
      });
    data.allObjectFields = enableList.value.map((i) => {
      return {
        label: i.fieldName,
        value: i.fieldKey,
        isRequired: i.isRequired ? 1 : 0,
        type: '50',
        fieldType: i.fieldType
      };
    });
  }
};
//关联主键
const associatedPrimaryKey = (val) => {
  data.sendType.modules.associateKey = val;
};
// 显示字段
const showField = (val) => {
  data.sendType.modules.associateField = val;
  data.sendType.modules.modules = data.allObjectFields.filter((v) => v.value === val);
};
// 默认值改变
const changeSelect = (v) => {
  console.log(88, v);
  data.sendType.modules.defaultValue = '';
  if (data.sendType.modules.fieldType === 6 || data.sendType.modules.fieldType === 22) {
    data.sendType.modules.fv = [];
  }
};
// 改变显示条件
const changeDisplay = (v) => {
  data.sendType.modules.display = v;
  console.log(1024, v);
  if (v == 0 || v == 1) {
    data.sendType.modules.displayConditions = null;
  }
};
// 改变是否必填
const changeRequired = (v) => {
  data.sendType.modules.isRequired = v;
  if (v == 0 || v == 1) {
    data.sendType.modules.requiredConditions = null;
  }
  if (v == 1 || v == 2) {
    //必填，满足条件必填时需要把显示条件显示成【默认可见】
    data.sendType.modules.display = 1;
    data.sendType.modules.displayConditions = null;
  }
};

// 获取文件列表
const getFiles = (files, fieldKey) => {
  console.log(1080, files, fieldKey);
  // 获取files.response.data的值,不要双层数组
  const filesList = [];
  if (files && files.length > 0) {
    files.forEach((v) => {
      if (v.response) {
        const url = v.response?.data;
        console.log(1081, ...url);
        filesList.push(...url);
      } else {
        filesList.push({ id: v?.id, name: v.name, url: v.url });
      }
    });
  }

  console.log(1083, filesList);
  data.sendType.modules.defaultValue = filesList;
  console.log(1161, data.sendType.modules.defaultValue);
};

// 配置区显示条件
const senData = (params) => {
  console.log(507, '回传的条件', params);
  // data.conditionType = 1 是否显示 data.conditionType = 2 是否必填 data.conditionType = 3 数据范围配置
  const condition = isDeepEmptyCondition(params);
  if (condition === null) {
    Message.warning(t('tips.conditionsConfig'));
  }
  if (data.conditionType === 1) {
    data.sendType.modules.displayConditions = condition;
  } else if (data.conditionType === 2) {
    data.sendType.modules.requiredConditions = condition;
  } else if (data.conditionType === 3) {
    data.sendType.modules.dataRangeConditions = condition;
  } else if (data.conditionType === 4) {
    data.sendType.modules[0].displayConditions = condition;
  }
};

//初始化获取关联主键，一个table只初始化调用一次
const getRelationKeys = async (businessData) => {
  data.findAssociation = [];
  await getViewFields({ id: businessData });
  data.findAssociation = enableList.value
    .filter((f) => f.fieldType === 12)
    .map((f) => {
      return { label: f.fieldName, value: f.fieldKey, fieldExt: f.fieldExt };
    });

  if (data.sendType?.page == 20 && data.sendType?.modules?.businessData && data.sendType?.modules?.type == '50') {
    data.allObjectFields = enableList.value.map((i) => {
      return {
        label: i.fieldName,
        value: i.fieldKey,
        isRequired: i.isRequired ? 1 : 0,
        type: '50',
        fieldType: i.fieldType
      };
    });
  }
};

const layoutFormRef = ref(); //表单配置
const layoutConfigRef = ref(); //属性配置
const parentPosition = reactive({
  //父级元素的位置
  top: 0,
  left: 0
});
const getParentRect = () => {
  const rect = data.fieldsKey == 2 ? layoutFormRef.value?.getBoundingClientRect() : layoutConfigRef.value?.getBoundingClientRect();

  const parentScrollTop = data.fieldsKey == 2 ? layoutFormRef.value.scrollTop : layoutConfigRef.value.scrollTop;
  parentPosition.top = rect.top;
  parentPosition.left = rect.left;
  parentPosition.scrollTop = data.fieldsKey == 2 ? parentScrollTop - 60 : parentScrollTop - 60;
  return parentPosition;
};
const provideMethds = {
  getParentRect: getParentRect
};
provide('parentData', provideMethds);

// tab按钮组回调
const onBtnConfigChange = (btnModules) => {
  layoutTableBtnModules.value[data.sendType.modules.value] = btnModules.data;

  data.sendType.modules.modules = btnModules.data?.modules?.filter((el) => el?.showField);
};

const targetFields = ref([]);
const sourceFields = ref([]);
const settingLoading = ref(false);
const memoRules = {
  require: true,
  validator: (value, cb) => {
    console.log('validator', value);
    if (data?.sendType?.modules?.memo) {
      if (data?.sendType?.modules?.memo?.length >= confine.number5001) {
        cb(`录入字符数已达上限${confine.number5000}位，请检查`);
      }
    }
  }
};
const toastRules = {
  require: true,
  validator: (value, cb) => {
    console.log('validator', value);
    if (data.sendType.modules.toast) {
      if (data.sendType.modules.toast?.length >= confine.number5001) {
        cb(`录入字符数已达上限${confine.number5000}位，请检查`);
      }
    }
  }
};
watch(
  () => data.sendType,
  async (v, o) => {
    if (Object.keys(data.sendType)?.length > 0) {
      data.fieldsKey = '1';
    }
    console.log('data.sendType------', data.sendType);
    if (!data.objectOptions?.length && data.sendType.modules?.layoutFieldType == '50') {
      //关联对象字段
      getObjectList();
    }
    if (data.sendType?.page == 20) {
      // 详情页布局
      if (data.sendType?.modules) {
        if (data.sendType?.area === 'module' && data.sendType?.modules[0]?.value == 1) {
          //协作人
          const handleType = {
            buttonList: data.allBtnGroup[0]?.values,
            type: 'follow',
            entity: pId.value
          };
          const filterBtns = getButtonResult(handleType);
          getBtnGroup(filterBtns, data.sendType?.modules[0]?.modules || [], 150);
        }
        // 页签区域
        if (data.sendType?.area === 'tab' && tabComponent.value.includes(data.sendType.modules.value) && !layoutTableBtnModules?.value[data.sendType.modules.value]?.allModules?.length) {
          const handleType = {
            buttonList: data.allBtnGroup[0]?.values,
            type: data.sendType.modules.value,
            entity: pId.value,
            isTab: true
          };
          const codeList = getButtonResult(handleType);

          const AllBtnModules = data.allBtnGroup[0]?.values?.filter((sourceItem) => codeList.includes(sourceItem.value));

          getBtnGroup(AllBtnModules, data.sendType?.modules?.modules, data.sendType.modules.value);
        }
      }
    }

    if (v?.modules?.id) {
      // 系统对象存在id
      if (v?.modules?.id !== o?.modules?.id) {
        isFirst.value = true;
      }
    } else if (v?.modules?.uniqueValue !== o?.modules?.uniqueValue) {
      // 拖动创建的表格不存在id，存在唯一标识uniqueValue
      isFirst.value = true;
    }

    if (data.sendType?.modules?.businessData && data.sendType?.modules?.layoutFieldType == '50' && isFirst.value && data.sendType?.page == 20) {
      isFirst.value = false;
      getRelationKeys(data.sendType?.modules?.businessData);
    } else {
      isFirst.value = true;
    }
    nextTick(() => {
      emits('cb', v);
    });
    if (typeof data.sendType == 'object' && Object.keys(data.sendType).length == 0) {
      //清空查找关联赋值逻辑数据
      defaultRule.autoCover = true;
      defaultRule.autoCoverAll = true;
      defaultRule.autoClear = true;
      defaultRule.cover = [{ source: null, target: null, targetFields: [], error: false }];
    }
    //查找关联查询配置规则用到的当前对象和关联对象的字段
    if ((data.sendType?.modules?.fieldType == 12 || (data.sendType?.modules?.fieldType == 25 && data.sendType?.modules?.parentFieldType == 27)) && data.sendType?.modules?.value != toggleFieldKey.value) {
      toggleFieldKey.value = data.sendType?.modules?.value;
      defaultRule.objName = data.sendType?.modules?.label;
      settingLoading.value = true;
      await getViewFields({ id: data.entity });
      targetFields.value = enableList.value;
      await getViewFields({ id: data.sendType?.modules?.fieldExt });
      settingLoading.value = false;
      //子表单查找关联不能选择12和25
      const filterFieldType = data.sendType?.modules?.parentFieldType == 27 ? [0, 1, 6, 7, 8, 11, 16, 22, 23] : [0, 1, 6, 7, 8, 11, 12, 16, 22, 23, 25];
      sourceFields.value = enableList.value.filter((v) => filterFieldType.includes(v.fieldType) || ([2, 3, 4, 5, 10].includes(v.fieldType) && v.globalFieldId !== null));
      defaultRule.autoCover = true;
      defaultRule.autoCoverAll = true;
      defaultRule.autoClear = true;
      defaultRule.cover = [{ source: null, target: null, targetFields: [], error: false }];
      if (data.sendType?.modules?.fieldAssignment) {
        defaultRule.autoCover = !!data.sendType?.modules?.fieldAssignment?.entityFieldRuleEvent?.eventAdd;
        defaultRule.autoCoverAll = !!data.sendType?.modules?.fieldAssignment?.entityFieldRuleEvent?.eventModify;
        defaultRule.autoClear = !!data.sendType?.modules?.fieldAssignment?.entityFieldRuleEvent?.eventClear;
        defaultRule.cover = [];
        if (data.sendType?.modules?.fieldAssignment?.fieldAssignmentRules?.length > 0) {
          data.sendType?.modules?.fieldAssignment?.fieldAssignmentRules.map((f, index) => {
            defaultRule.cover.push({
              source: f.sourceField,
              target: f.targetField,
              targetFields: [],
              error: false
            });
            nextTick(() => {
              changeFirst(index, false);
            });
          });
        }
      }
    }
  },
  {
    immediate: true,
    deep: true
  }
);
// 表单的回调
const updateFormConfig = (formCallBack) => {
  data.form = formCallBack;
};
//抛出基本信息，布局名称，按钮等
const sendBasicConfig = () => {
  return data.form;
};
//设置基本信息，布局名称，按钮等
const setBasicConfig = () => {
  data.fieldsKey = '2';
};
defineExpose({ sendBasicConfig, setBasicConfig });
</script>
<style scoped lang="less">
@import './layout-config-area.less';
</style>
